<template>
   <div class="large-card">
      <nuxt-link
         :to="
            routeForResource({
               slug: card?.slug,
               type: card?.type ?? type,
               discipline: discipline,
            })
         "
         :custom="!published"
      >
         <!-- background image -->
         <Image
            v-if="card.image"
            :image="card.image"
            :key="card.image.src"
            fit="cover"
         />
         <!-- tags -->
         <div class="tags">
            <!-- if SAVED -->
            <Tag
               v-if="savable"
               class="unsave action"
               role="button"
               v-on:click.prevent="unsave"
            >
               Unsave
            </Tag>
            <!-- NEW -->
            <Tag v-if="card?.new_flag" class="new">New</Tag>
            <!-- UPDATED -->
            <Tag v-if="card?.update_flag" class="updated">Updated</Tag>
            <Tag v-if="onboardingCourses?.includes(card.slug)" class="onboarding">Onboarding</Tag>

            <!-- <p class="tag label coming-soon">Coming Soon</p> -->

            <!-- search or related core work - show discipline -->
            <Tag v-if="discipline" class="discipline" :class="[discipline]">{{
               discipline
            }}</Tag>
         </div>

         <!-- text -->
         <div class="text">
            <h4 class="sans bold">{{ card.title }}</h4>
            <!-- <p class="small">{{ card.description }}</p> -->
            <p
               v-if="card?.description && isHtml(card?.description)"
               class="small"
               v-html="card.description"
            ></p>
            <p class="small description" v-else>{{ card?.description }}</p>
            <p class="xsmall grey-dk" v-if="card.age_group">
               {{ card?.readable_age_group ?? card.age_group }} | {{ meta }}
            </p>
            <p class="xsmall grey-dk" v-if="card.section_count">
               {{ card.section_count }} Sections | {{ meta }}
            </p>
         </div>
      </nuxt-link>
   </div>
</template>

<script setup lang="ts">
const route = useRoute();
const { saveUnitToProfile } = useUnit();
const { savePdToProfile } = usePd();
const { logError } = useDebugger();
const { onboardingCourses = [] } = usePd();

const props = defineProps({
   card: { type: Object, required: true },
   type: { type: String, default: null },
   savable: { type: Boolean, default: false },
});

const meta = computed(() =>
   props.card.teachables_count
      ? `${props.card.teachables_count} Teachables`
      : props.card.sections_total_duration &&
        formatTime(props.card.sections_total_duration),
);
// Get Discipline
const discipline = computed(
   () =>
      props.card?.discipline?.slug ??
      (props.card?.discipline_id &&
         disciplineText(props.card?.discipline_id)) ??
      route.params?.discipline,
);

// const showActionSave = computed(() =>
//    ["profile-units", "profile-pd"].includes(route.name)
// );
const published = computed(() => props.card.status === "published");

const unsave = async () => {
   try {
      switch (route.name) {
         case "profile-units":
            await saveUnitToProfile(props.card.slug, "DELETE");
            break;
         case "profile-pd":
            await savePdToProfile(props.card.slug, "DELETE", props.card?.title);
            break;
      }
   } catch (err) {
      logError("LargeCard unsave failed", err);
   }
};
</script>

<style lang="scss" scoped>
@import "~/assets/scss/globals/large-card";
</style>
